import type { AuthPermission } from "@/types";

export function useResourceAuth(auth?: Record<string, AuthPermission>) {
  const can = (action: string): boolean => auth?.[action]?.has ?? false;
  const getPermission = (action: string): AuthPermission | undefined =>
    auth?.[action];
  return { can, getPermission };
}
